<template>
  <header class="sitenav">
    <div class="">
      <div class="row">
        <div class="col-12">
          <b-navbar toggleable="lg" class="d-flex align-items-start" type="light" v-bind:class="{sticky: isFixed == true}">
            
            
            <b-navbar-brand to="/" >
              <img
                class="img-fluid"
                src="../assets/imgs/arreglalo/arreglalo_logo_300.png"
                alt="Arréglalo"
              />
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" class="pt-0 pt-lg-3 pr-5" is-nav>
              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">
                <template>
                 
                  
                  <!-- <b-nav-item
                    class="fC btnrojo text-center pt-4 bold"
                    to="/ganadores"
                  >Ganadores</b-nav-item> -->
                </template>
                
                 <b-nav-item class="fG btnrojo text-center pt-2 bold cerrarsesion bold" @click="toggleOverlay()">
                  CONTÁCTANOS
                </b-nav-item>
                 

                <!-- <b-nav-item class="fC btnrojo text-center pt-2 bold cerrarsesion" @click="logout()">
                  Cerrar sesión
                  
                </b-nav-item> -->
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import * as fb from "../firebase";
export default {
  data() {
    return {
      uid: null,
      stickyTop: 10,
      isFixed: false
    };
  },
  computed: {},
 created: function (){
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function (){
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted: function () {
    //this.uid = fb.auth.currentUser.uid;
    
  },
  methods: {
    handleScroll (event) {
      // Any code to be executed when the window is scrolled
      console.log('scroll')
      console.log(window.scrollY)

      if(window.scrollY > 10){
        this.isFixed = true;
      }else{
        this.isFixed = false;
      }
    },
    logout() {
      this.$store.dispatch("logout");
    },
    toggleOverlay() {
      this.$store.state.overlay = !this.$store.state.overlay;

      console.log({click: this.$store.state.overlay})
    },
  },
};
</script>
